import AvailableSection from './AvailableSection.vue'

export default AvailableSection
